
    import {Options, Vue} from 'vue-property-decorator';
    import type {ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import {ExperienceLevel} from '@/profile-creation-wizard/components/for-creation/store';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';

    type ExperienceLevelContent = {
        label: string;
        description: string;
    };

    @Options({})
    export default class CategorizationLevelSelection extends Vue {
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;

        experienceLevels: ExperienceLevel[] = [];
        selectedExperienceLevel: ExperienceLevel | null = null;

        created(): void {
            this.experienceLevels = this.getExperienceLevels();
            this.selectedExperienceLevel = this.creationForm.experienceLevel;
        }

        get jobTitle(): string {
            return this.creationForm.headline!;
        }

        selectExperienceLevel(customEvent: CustomEvent): void {
            if (customEvent.detail.checked) {
                this.$store.commit(mutations.selectExperienceLevel, customEvent.detail.value);
            } else {
                this.$store.commit(mutations.unselectExperienceLevel);
            }
        }

        isSelectedLevel(experienceLevel: ExperienceLevel) {
            return experienceLevel === this.selectedExperienceLevel;
        }

        experienceLevelId(experienceLevel: ExperienceLevel): string {
            return `profile-creation-details-experience-level-${experienceLevel.toLowerCase()}`;
        }

        getExperienceLevels(): ExperienceLevel[] {
            if (this.$features.freelancerConvergenceSignup) {
                return Object.values(ExperienceLevel);
            } else {
                return [ExperienceLevel.ENTRY, ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT];
            }
        }

        getExperienceLevelContent(experienceLevel: ExperienceLevel): ExperienceLevelContent {
            if (this.$features.freelancerConvergenceSignup) {
                return {
                    label: this.$msg(`profile.creation.completion.wizard.categorization.experienceLevel.label.v2.${experienceLevel}`),
                    description: this.$msg(`profile.creation.completion.wizard.categorization.experienceLevel.description.v2.${experienceLevel}`),
                };
            } else {
                return {
                    label: this.$msg(`profile.creation.completion.wizard.categorization.experienceLevel.label.${experienceLevel}`),
                    description: this.$msg(`profile.creation.completion.wizard.categorization.experienceLevel.description.${experienceLevel}`),
                };
            }
        }
    }
